/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { LineChart } from "../../../../models/http/charts/line-chart/line-chart.model";
import { KPI } from "../../../../models/http/dashboard/kpi.model";

export const GET_FILES_RESPONSE = {
	files: [
		{
			name: "file1.xlsx",
			id: "1"
		},
		{
			name: "file2.xlsx",
			id: "2"
		},
		{
			name: "file3.xlsx",
			id: "3"
		}
	]
};

export const EMISSION_RECORDS = [
	{
		id: 0,
		applicationId: "AQUILA-CRM",
		provider: {
			name: "OpenAI",
			model: "GPT-5"
		},
		nTokens: 985,
		energy: {
			value: 0.52,
			uncertainty: 0.08,
			unit: "kWh"
		},
		emission: {
			value: 118.4,
			uncertainty: 6.2,
			unit: "kgCO2e"
		},
		wu: {
			value: 210.6,
			uncertainty: 5.4,
			unit: "L"
		}
	},
	{
		id: 1,
		applicationId: "NIMBUS-CHAT",
		provider: {
			name: "Anthropic",
			model: "Claude-3"
		},
		nTokens: 1420,
		energy: {
			value: 0.67,
			uncertainty: 0.09,
			unit: "kWh"
		},
		emission: {
			value: 152.8,
			uncertainty: 7.1,
			unit: "kgCO2e"
		},
		wu: {
			value: 265.4,
			uncertainty: 7.9,
			unit: "L"
		}
	},
	{
		id: 2,
		applicationId: "HELIOS-BI",
		provider: {
			name: "Google",
			model: "Gemini Advanced"
		},
		nTokens: 640,
		energy: {
			value: 0.41,
			uncertainty: 0.05,
			unit: "kWh"
		},
		emission: {
			value: 97.3,
			uncertainty: 4.8,
			unit: "kgCO2e"
		},
		wu: {
			value: 188.9,
			uncertainty: 4.1,
			unit: "L"
		}
	},
	{
		id: 3,
		applicationId: "SENTINEL-OPS",
		provider: {
			name: "Microsoft",
			model: "Sydney"
		},
		nTokens: 880,
		energy: {
			value: 0.48,
			uncertainty: 0.06,
			unit: "kWh"
		},
		emission: {
			value: 103.6,
			uncertainty: 5.2,
			unit: "kgCO2e"
		},
		wu: {
			value: 201.1,
			uncertainty: 4.9,
			unit: "L"
		}
	},
	{
		id: 4,
		applicationId: "ORION-ANALYTICS",
		provider: {
			name: "OpenAI",
			model: "GPT-4.1"
		},
		nTokens: 1240,
		energy: {
			value: 0.58,
			uncertainty: 0.07,
			unit: "kWh"
		},
		emission: {
			value: 131.2,
			uncertainty: 6.4,
			unit: "kgCO2e"
		},
		wu: {
			value: 223.9,
			uncertainty: 6.1,
			unit: "L"
		}
	},
	{
		id: 5,
		applicationId: "LYRA-SUPPORT",
		provider: {
			name: "Anthropic",
			model: "Claude-3.5"
		},
		nTokens: 980,
		energy: {
			value: 0.49,
			uncertainty: 0.06,
			unit: "kWh"
		},
		emission: {
			value: 110.7,
			uncertainty: 5.6,
			unit: "kgCO2e"
		},
		wu: {
			value: 196.4,
			uncertainty: 5.2,
			unit: "L"
		}
	},
	{
		id: 6,
		applicationId: "VEGA-INSIGHTS",
		provider: {
			name: "Google",
			model: "Gemini Pro"
		},
		nTokens: 760,
		energy: {
			value: 0.44,
			uncertainty: 0.05,
			unit: "kWh"
		},
		emission: {
			value: 99.1,
			uncertainty: 4.7,
			unit: "kgCO2e"
		},
		wu: {
			value: 182.7,
			uncertainty: 4.3,
			unit: "L"
		}
	},
	{
		id: 7,
		applicationId: "PULSAR-OPS",
		provider: {
			name: "Microsoft",
			model: "Copilot"
		},
		nTokens: 1560,
		energy: {
			value: 0.73,
			uncertainty: 0.1,
			unit: "kWh"
		},
		emission: {
			value: 168.9,
			uncertainty: 7.8,
			unit: "kgCO2e"
		},
		wu: {
			value: 294.2,
			uncertainty: 8.2,
			unit: "L"
		}
	},
	{
		id: 8,
		applicationId: "ZENITH-SEARCH",
		provider: {
			name: "OpenAI",
			model: "GPT-4o"
		},
		nTokens: 690,
		energy: {
			value: 0.39,
			uncertainty: 0.04,
			unit: "kWh"
		},
		emission: {
			value: 90.4,
			uncertainty: 4.1,
			unit: "kgCO2e"
		},
		wu: {
			value: 176.2,
			uncertainty: 3.9,
			unit: "L"
		}
	},
	{
		id: 9,
		applicationId: "AURORA-AI",
		provider: {
			name: "Anthropic",
			model: "Claude-3"
		},
		nTokens: 1110,
		energy: {
			value: 0.54,
			uncertainty: 0.07,
			unit: "kWh"
		},
		emission: {
			value: 124.6,
			uncertainty: 6.1,
			unit: "kgCO2e"
		},
		wu: {
			value: 211.3,
			uncertainty: 5.8,
			unit: "L"
		}
	},
	{
		id: 10,
		applicationId: "ECHO-ASSIST",
		provider: {
			name: "Google",
			model: "Gemini Advanced"
		},
		nTokens: 1320,
		energy: {
			value: 0.62,
			uncertainty: 0.08,
			unit: "kWh"
		},
		emission: {
			value: 140.5,
			uncertainty: 6.9,
			unit: "kgCO2e"
		},
		wu: {
			value: 238.7,
			uncertainty: 6.7,
			unit: "L"
		}
	},
	{
		id: 11,
		applicationId: "NOVA-CARE",
		provider: {
			name: "Microsoft",
			model: "Phi-4"
		},
		nTokens: 540,
		energy: {
			value: 0.33,
			uncertainty: 0.04,
			unit: "kWh"
		},
		emission: {
			value: 76.2,
			uncertainty: 3.5,
			unit: "kgCO2e"
		},
		wu: {
			value: 149.6,
			uncertainty: 3.2,
			unit: "L"
		}
	},
	{
		id: 12,
		applicationId: "METEOR-HELPDESK",
		provider: {
			name: "OpenAI",
			model: "GPT-4"
		},
		nTokens: 1490,
		energy: {
			value: 0.71,
			uncertainty: 0.09,
			unit: "kWh"
		},
		emission: {
			value: 162.3,
			uncertainty: 7.4,
			unit: "kgCO2e"
		},
		wu: {
			value: 281.8,
			uncertainty: 7.7,
			unit: "L"
		}
	},
	{
		id: 13,
		applicationId: "SOLARIS-AUDIT",
		provider: {
			name: "Anthropic",
			model: "Claude-2"
		},
		nTokens: 620,
		energy: {
			value: 0.37,
			uncertainty: 0.04,
			unit: "kWh"
		},
		emission: {
			value: 84.9,
			uncertainty: 3.9,
			unit: "kgCO2e"
		},
		wu: {
			value: 166.5,
			uncertainty: 3.7,
			unit: "L"
		}
	},
	{
		id: 14,
		applicationId: "NEBULA-RISK",
		provider: {
			name: "Google",
			model: "Gemini Pro"
		},
		nTokens: 870,
		energy: {
			value: 0.47,
			uncertainty: 0.05,
			unit: "kWh"
		},
		emission: {
			value: 106.8,
			uncertainty: 5.1,
			unit: "kgCO2e"
		},
		wu: {
			value: 193.4,
			uncertainty: 4.6,
			unit: "L"
		}
	},
	{
		id: 15,
		applicationId: "ATLAS-FORECAST",
		provider: {
			name: "Microsoft",
			model: "Phi-3"
		},
		nTokens: 1010,
		energy: {
			value: 0.55,
			uncertainty: 0.06,
			unit: "kWh"
		},
		emission: {
			value: 119.9,
			uncertainty: 5.9,
			unit: "kgCO2e"
		},
		wu: {
			value: 209.7,
			uncertainty: 5.3,
			unit: "L"
		}
	}
];

export const FILE_STATUS_RESPONSE = {
	status: "DONE",
	message: "Processing completed successfully."
};

export const GET_EMISSIONS_RESPONSE = {
	first: true,
	last: true,
	size: 10,
	totalElements: EMISSION_RECORDS.length,
	totalPages: 1,
	number: 0,
	contents: EMISSION_RECORDS
};

export const EXPORT_FILE_RESPONSE =
	"Y29tcGFueSxtb2RlbCx0b2tlbnMsZW5lcmd5X3doLGVtaXNzaW9uc19nQ28yZXEK";

export const AI_GENERAL_INFORMATION_RESPONSE: {
	totalCo2Emission: KPI;
	totalWaterUsage: KPI;
	countApplications: KPI;
} = {
	totalCo2Emission: {
		label: "Total CO2e Emissions",
		value: 472,
		unit: "kgCO2e"
	},
	totalWaterUsage: {
		label: "Total Water Usage",
		value: 866,
		unit: "L"
	},
	countApplications: {
		label: "Total Applications",
		value: 16,
		unit: ""
	}
};

const TIMELINE_LABELS = [
	"2025-01-01",
	"2025-02-01",
	"2025-03-01",
	"2025-04-01",
	"2025-05-01",
	"2025-06-01"
];

const buildLineSerie = (name: string, unit: string, values: number[]) => ({
	name,
	linePoints: TIMELINE_LABELS.map((label, index) => ({
		name: label,
		value: values[index] ?? 0,
		unit
	}))
});

export const AI_CO2_APPS_PERFORMANCE_RESPONSE: LineChart = {
	title: "My running Apps - CO2e Emissions",
	lineSeries: [
		buildLineSerie("Aquila CRM - North America", "kgCO2e", [95, 102, 110, 121, 134, 146]),
		buildLineSerie("Aquila CRM - EMEA", "kgCO2e", [74, 78, 85, 94, 101, 109]),
		buildLineSerie("Aquila CRM - APAC", "kgCO2e", [68, 72, 79, 88, 96, 104]),
		buildLineSerie("Nimbus Chat - Customer Support", "kgCO2e", [88, 92, 99, 111, 118, 125]),
		buildLineSerie("Nimbus Chat - Sales Enablement", "kgCO2e", [61, 66, 72, 79, 87, 94]),
		buildLineSerie("Helios BI - Retail Analytics", "kgCO2e", [52, 57, 63, 71, 79, 86]),
		buildLineSerie("Sentinel Ops - Security Insights", "kgCO2e", [69, 74, 81, 89, 97, 105]),
		buildLineSerie("Orion Analytics - Finance", "kgCO2e", [73, 79, 86, 95, 103, 112]),
		buildLineSerie("Lyra Support - Tier 1", "kgCO2e", [56, 61, 67, 74, 81, 89]),
		buildLineSerie("Vega Insights - Marketing", "kgCO2e", [49, 53, 59, 66, 73, 80]),
		buildLineSerie("Pulsar Ops - Workforce", "kgCO2e", [77, 83, 91, 101, 110, 120]),
		buildLineSerie("Zenith Search - Knowledge Base", "kgCO2e", [45, 49, 55, 62, 69, 76]),
		buildLineSerie("Aurora AI - RnD Experiments", "kgCO2e", [58, 63, 70, 78, 86, 94]),
		buildLineSerie("Nova Care - Patient Outreach", "kgCO2e", [51, 56, 62, 69, 76, 83]),
		buildLineSerie("Meteor Helpdesk - IT Ops", "kgCO2e", [64, 69, 76, 84, 92, 101]),
		buildLineSerie("Solaris Audit - Compliance", "kgCO2e", [47, 51, 57, 64, 71, 78])
	]
};

export const AI_WATER_APPS_PERFORMANCE_RESPONSE: LineChart = {
	title: "My running Apps - Water Consumption",
	lineSeries: [
		buildLineSerie("Aquila CRM - North America", "L", [160, 172, 185, 197, 214, 228]),
		buildLineSerie("Aquila CRM - EMEA", "L", [128, 136, 148, 159, 170, 182]),
		buildLineSerie("Aquila CRM - APAC", "L", [118, 126, 137, 148, 160, 172]),
		buildLineSerie("Nimbus Chat - Customer Support", "L", [140, 152, 166, 174, 183, 195]),
		buildLineSerie("Nimbus Chat - Sales Enablement", "L", [104, 112, 123, 132, 144, 156]),
		buildLineSerie("Helios BI - Retail Analytics", "L", [96, 104, 116, 125, 137, 148]),
		buildLineSerie("Sentinel Ops - Security Insights", "L", [122, 131, 145, 156, 169, 182]),
		buildLineSerie("Orion Analytics - Finance", "L", [130, 139, 152, 164, 177, 190]),
		buildLineSerie("Lyra Support - Tier 1", "L", [108, 118, 129, 140, 152, 165]),
		buildLineSerie("Vega Insights - Marketing", "L", [92, 101, 112, 123, 135, 146]),
		buildLineSerie("Pulsar Ops - Workforce", "L", [146, 158, 172, 186, 201, 216]),
		buildLineSerie("Zenith Search - Knowledge Base", "L", [88, 96, 106, 117, 129, 141]),
		buildLineSerie("Aurora AI - RnD Experiments", "L", [110, 120, 132, 145, 158, 172]),
		buildLineSerie("Nova Care - Patient Outreach", "L", [101, 110, 121, 132, 144, 156]),
		buildLineSerie("Meteor Helpdesk - IT Ops", "L", [116, 126, 138, 151, 165, 180]),
		buildLineSerie("Solaris Audit - Compliance", "L", [90, 99, 109, 120, 132, 144])
	]
};

export interface CompanyImpactSeed {
	company: string;
	modelCount: number;
	emission: number;
}

export const AI_COMPANY_IMPACT_SUMMARY: CompanyImpactSeed[] = [
	{ company: "OpenAI", modelCount: 4, emission: 520 },
	{ company: "Anthropic", modelCount: 3, emission: 340 },
	{ company: "Google", modelCount: 5, emission: 280 },
	{ company: "Microsoft", modelCount: 2, emission: 190 }
];

export interface ModelImpactSeed {
	company: string;
	model: string;
	rowCount: number;
	totalEmissions: number;
	emissionPerTokenUnit: number;
}

export const AI_MODEL_IMPACT_SUMMARY: ModelImpactSeed[] = [
	{
		company: "OpenAI",
		model: "GPT-5",
		rowCount: 85,
		totalEmissions: 249.6,
		emissionPerTokenUnit: 2.93
	},
	{
		company: "OpenAI",
		model: "GPT-4.1",
		rowCount: 64,
		totalEmissions: 131.2,
		emissionPerTokenUnit: 2.05
	},
	{
		company: "OpenAI",
		model: "GPT-4o",
		rowCount: 57,
		totalEmissions: 139.2,
		emissionPerTokenUnit: 2.44
	},
	{
		company: "Anthropic",
		model: "Claude-3",
		rowCount: 98,
		totalEmissions: 277.4,
		emissionPerTokenUnit: 2.83
	},
	{
		company: "Anthropic",
		model: "Claude-3.5",
		rowCount: 72,
		totalEmissions: 62.6,
		emissionPerTokenUnit: 0.87
	},
	{
		company: "Google",
		model: "Gemini Advanced",
		rowCount: 110,
		totalEmissions: 280.5,
		emissionPerTokenUnit: 2.55
	},
	{
		company: "Microsoft",
		model: "Sydney",
		rowCount: 60,
		totalEmissions: 103.6,
		emissionPerTokenUnit: 1.73
	},
	{
		company: "Microsoft",
		model: "Copilot",
		rowCount: 78,
		totalEmissions: 86.4,
		emissionPerTokenUnit: 1.11
	}
];

export interface WaterUsageSeed {
	company: string;
	model: string;
	totalWaterUsage: number;
	waterUsagePerTokenUnit: number;
}

export const AI_WATER_USAGE_BY_MODEL_SUMMARY: WaterUsageSeed[] = [
	{ company: "OpenAI", model: "GPT-5", totalWaterUsage: 432.8, waterUsagePerTokenUnit: 5.09 },
	{ company: "OpenAI", model: "GPT-4.1", totalWaterUsage: 223.9, waterUsagePerTokenUnit: 3.5 },
	{ company: "OpenAI", model: "GPT-4o", totalWaterUsage: 176.2, waterUsagePerTokenUnit: 3.09 },
	{
		company: "Anthropic",
		model: "Claude-3",
		totalWaterUsage: 476.7,
		waterUsagePerTokenUnit: 4.86
	},
	{
		company: "Anthropic",
		model: "Claude-3.5",
		totalWaterUsage: 196.4,
		waterUsagePerTokenUnit: 2.73
	},
	{
		company: "Google",
		model: "Gemini Advanced",
		totalWaterUsage: 427.6,
		waterUsagePerTokenUnit: 3.89
	},
	{ company: "Microsoft", model: "Sydney", totalWaterUsage: 201.1, waterUsagePerTokenUnit: 3.35 },
	{ company: "Microsoft", model: "Copilot", totalWaterUsage: 294.2, waterUsagePerTokenUnit: 3.77 }
];

export const AI_BEST_10_EMISSIONS_PER_TOKEN_RESPONSE = {
	title: "Top 10 models by emissions per token",
	barSeries: [
		{
			name: "Emissions per token",
			bars: [...AI_MODEL_IMPACT_SUMMARY]
				.sort((a, b) => a.emissionPerTokenUnit - b.emissionPerTokenUnit)
				.slice(0, 10)
				.map(entry => ({
					name: `${entry.company} / ${entry.model}`,
					value: entry.emissionPerTokenUnit,
					unit: "kgCO2e / 1M tokens"
				}))
		}
	]
};

export const AI_BEST_10_WATER_USAGE_PER_TOKEN_RESPONSE = {
	title: "Top 10 models by water usage per token",
	barSeries: [
		{
			name: "Water usage per token",
			bars: [...AI_WATER_USAGE_BY_MODEL_SUMMARY]
				.sort((a, b) => a.waterUsagePerTokenUnit - b.waterUsagePerTokenUnit)
				.slice(0, 10)
				.map(entry => ({
					name: `${entry.company} / ${entry.model}`,
					value: entry.waterUsagePerTokenUnit,
					unit: "L / 1M tokens"
				}))
		}
	]
};
